module.exports = __webpack_public_path__ + "static/media/motorboat_disabled_ic.b7921943.svg";